import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#0a0a0a]">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-[#c9a96e] border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // First-login onboarding: block the app until the temporary password is changed.
  // Only new users carry this flag → existing users are unaffected.
  if (user?.profile?.must_change_password) {
    return <Navigate to="/change-password" replace />;
  }

  return children;
};

export default PrivateRoute;
